import React, { useEffect, useContext, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { UserOrderContext } from 'context/context';
import {
  getHeaderContentData,
  getHeaderData,
  getFooterData,
  getTenantData,
  getDispositionTypeOnAPIFormat,
  getDispositionFomat,
  setStoreOutOfService,
  getFullImagePath,
  isEmptyEvery,
} from '../../../common/utilities/utils';
import { StartOrderComponent } from '../../../organisms/StartOrderComponent';
import HOME_PAGE_CONTAINER_CONSTANTS from '../Constants/homePageContainerConstants';
import { Footer } from 'organisms/FooterComponent';
import { Header } from 'organisms/HeaderComponent';
import 'bootstrap/dist/css/bootstrap.min.css';
import MenuPDPContainer from 'organisms/MenuPDPPage/Container/MenuPDPContainer';
import { ClearCartModule } from 'organisms/ClearCartModule/Container/ClearCartComponent';
import { getContent, getMarketConfigContent } from 'common/utilities/content';
import { useParams } from 'react-router-dom';
import { PRODUCT_PAGE } from '../../../common/constants/SharedConstants';
import { StructureData } from 'organisms/StructureDataComponent';

export const getSeoPageWithObject = (tenantReducer, categoryMapByUrl, categoryUrl, productUrl) => {
  const matchedCategory = categoryMapByUrl?.[categoryUrl];
  const matchedProduct = matchedCategory?.productMapByProductUrl?.[productUrl];

  if (matchedCategory && matchedProduct) {
    const {
      dname: [{ value: Product } = {}] = [],
      shortDescription: [{ value: sd } = {}] = [],
      imageName,
      imageObj: productImage = [],
      content: productContent,
    } = matchedProduct ?? {};
    const productImgPath = imageName || getFullImagePath(productImage, tenantReducer);

    const { shortDescription: ProductDescription = sd, image: { mainImage: ProductImage = productImgPath } = {} } =
      productContent || {};

    const seoPageName = PRODUCT_PAGE;
    const { dname: [{ value: Category } = {}] = [] } = matchedCategory ?? {};
    const seoObject = {
      Category,
      CategoryURL: `${window?.location?.origin ?? '/'}/menu/${categoryUrl}`,
      Product,
      ProductDescription,
      ProductImage,
    };

    return { seoPageName, seoObject };
  }
};

const ProductDescriptionPage = props => {
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const tenantReducer = useSelector(data => data.tenantReducer);
  const { flatResponse: { categoryMapByUrl = {} } = {} } = useSelector(({ menuReducer }) => menuReducer) ?? {};
  const { category_name, product_name } = useParams();
  const [seoPage, setSeoPage] = useState(PRODUCT_PAGE);
  const [seoObj, setSeoObj] = useState();
  const dispositionNew = isEmptyEvery(userOrderState.dispositionNew)
    ? JSON.parse(localStorage.getItem('dispositionNew'))
    : userOrderState.dispositionNew;
  const params = useMemo(() => {
    return {
      tenantReducer: tenantReducer ?? JSON.parse(localStorage.getItem('tenantReducer')),
      storeInfo: dispositionNew?.store ?? {},
      selectedDate: dispositionNew?.date,
      selectedTime: dispositionNew?.time,
      dispositionType: getDispositionTypeOnAPIFormat(
        dispositionNew?.type || tenantReducer.authoredContent?.defaultdisposition,
      ),
      selectedTile: userOrderState?.selectedTile || JSON.parse(localStorage.getItem('selectedTile')),
    };
  }, [dispositionNew, tenantReducer, userOrderState]);

  let segmentedHomePageData = null,
    segmentedMarketingData = null,
    segmentedTenantData = null,
    segmentedFooterData = null;

  const { DISPOSITION } = HOME_PAGE_CONTAINER_CONSTANTS;

  const dispatch = useDispatch();

  let userParams = useSelector(data => data.appStateReducer.userStatus);

  /**
   * Store Closed Callback
   */
  const setStoreClosedInfo = currentStoreInfo => {
    setStoreOutOfService(
      currentStoreInfo,
      userOrderStateDispatch,
      dispositionNew,
      getDispositionFomat(params.dispositionType),
    );
  };

  useEffect(() => {
    dispatch(getMarketConfigContent(tenantReducer));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, tenantReducer?.country]);

  useEffect(() => {
    dispatch(getContent(userParams));
  }, [dispatch, userParams]);

  useEffect(() => {
    const { seoPageName, seoObject } =
      getSeoPageWithObject(tenantReducer, categoryMapByUrl, category_name, product_name) ?? {};
    setSeoPage(seoPageName);
    setSeoObj(seoObject);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category_name, product_name, JSON.stringify(categoryMapByUrl)]);

  /**
   * method to setup content data for home page config
   */
  const allReducerData = useSelector(data => {
    return {
      homePageContent: data.contentReducer.response,
      marketPageContent: data.marketConfigReducer.response,
      tenantReducerContent: data.tenantReducer,
    };
  });

  if (allReducerData.marketPageContent && allReducerData.tenantReducerContent && allReducerData.homePageContent) {
    segmentedHomePageData = getHeaderContentData(allReducerData.homePageContent) || null;
    const { header = {}, footer = {} } = allReducerData.marketPageContent.headerData || {};
    segmentedMarketingData = getHeaderData(header);
    segmentedFooterData = getFooterData(footer);
  }
  return (
    <React.Fragment>
      {seoPage && <StructureData page={seoPage} seoObj={seoObj} />}
      {segmentedMarketingData && (
        <Header
          contentData={segmentedMarketingData}
          tenantReducerData={allReducerData.tenantReducerContent}
          userParams={userParams}
        />
      )}
      <StartOrderComponent
        contentData={{
          segmentedHomePageData: segmentedHomePageData?.[DISPOSITION],
          contentDispositionData: segmentedHomePageData?.[DISPOSITION],
        }}
        userParams={userParams}
      />
      <MenuPDPContainer
        tenantData={tenantReducer}
        contentData={params}
        {...props}
        setStoreClosedInfo={setStoreClosedInfo}
      />
      {segmentedFooterData && (
        <Footer
          history={props.history}
          contentData={segmentedFooterData}
          tenantReducerData={allReducerData.tenantReducerContent}
        />
      )}
      {userOrderState.showCartClearAlert && <ClearCartModule />}
    </React.Fragment>
  );
};
export default ProductDescriptionPage;
